import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";

/**
 * Outcome of an add-winners batch. Every row is independent: some can succeed while others fail,
 * so each row is shown with the message the backend returned for it, and only the failed rows can
 * be retried.
 */
export default function AddWinnersResults(props) {
     const { result, rows, onDone } = props;

     if (!result) {
          return null;
     }

     const results = result.results || [];

     const resultRows = results.map((rowResult) => {
          const submitted = rows[rowResult.rowIndex] || {};

          return {
               ...rowResult,
               rowNumber: rowResult.rowIndex + 1,
               name: `${submitted.firstName || ""} ${submitted.lastName || ""}`.trim(),
               outcome: rowResult.isSuccess ? "Added" : "Failed",
               // The backend echoes back the week it stored. A failed row has none, so fall back to
               // whatever was submitted, which is what the user needs to see to fix it.
               week: rowResult.week || submitted.week || "",
          };
     });

     const rowRender = (row, rowProps) => {
          if (rowProps.dataItem.isSuccess) {
               return row;
          }

          return React.cloneElement(row, {
               ...row.props,
               style: { ...row.props.style, backgroundColor: "#fdecea" },
          });
     };

     return (
          <div style={{ marginTop: "24px" }}>
               <h4>
                    {result.succeeded} of {result.total} added
                    {result.failed > 0 ? `, ${result.failed} failed` : ""}
               </h4>

               <Grid
                    data={resultRows}
                    className="sba-area-data-grid"
                    rowRender={rowRender}
               >
                    <GridColumn field="rowNumber" title="Row" width="80px" />
                    <GridColumn field="name" title="Winner" width="180px" />
                    <GridColumn field="email" title="Email" width="250px" />
                    <GridColumn field="week" title="Week" width="100px" />
                    <GridColumn field="outcome" title="Outcome" width="120px" />
                    <GridColumn field="message" title="Message" width="320px" />
                    <GridColumn
                         field="pointsCredited"
                         title="Points"
                         width="110px"
                    />
               </Grid>

               <div style={{ marginTop: "16px" }}>
                    <Button type="button" themeColor="primary" onClick={onDone}>
                         Done
                    </Button>
               </div>
          </div>
     );
}
